import {logger} from "@/services/logger.service";

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs, elementId) {
    var startTimeInMs = Date.now();
    (function loopSearchForElement() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        } else {
            logger.debug("Wait for spinner with id 'spinner-" + elementId )
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
                    logger.debug("Timeout for spinner with id 'spinner-" + elementId)
                    return;
                }
                loopSearchForElement();
            }, checkFrequencyInMs);
        }
    })();
}

function showAfterWait(elementId, anotherElementId) {
    var spinner = document.querySelector('#spinner-' + elementId);
    if (spinner != null) {
        logger.debug("Show spinner with id 'spinner-" + elementId + "'")
        spinner.style.display = 'block'
    } else {
        logger.debug("Spinner with id 'spinner-" + elementId + "' not found")
    }
    var element = document.querySelector('#' + elementId);
    if (element != null) {
        logger.debug("Hide element with id '" + elementId + "'")
        element.style.visibility = 'hidden'
    } else {
        logger.debug("Element with id " + elementId + " not found")
    }
    if (anotherElementId) {
        var anotherElement = document.querySelector('#' + anotherElementId);
        if (anotherElement != null) {
            anotherElement.style.visibility = 'hidden'
        } else {
            logger.debug("Another element with id " + anotherElementId + " not found")
        }
    }
}

function hideAfterWait(elementId, anotherElementId) {
    var spinner = document.querySelector('#spinner-' + elementId);
    if (spinner != null) {
        logger.debug("Hide spinner with id 'spinner-" + elementId + "'")
        spinner.style.display = 'none'
    } else {
        logger.debug("Spinner with id 'spinner-" + elementId + "' not found")
    }
    var element = document.querySelector('#' + elementId);
    if (element != null) {
        logger.debug("Show element with id '" + elementId + "'")
        element.style.visibility = 'visible'
    } else {
        logger.debug("Element with id " + elementId + " not found")
    }
    if (anotherElementId) {
        var anotherElement = document.querySelector('#' + anotherElementId);
        if (anotherElement != null) {
            anotherElement.style.visibility = 'visible'
        } else {
            logger.debug("Another element with id " + anotherElementId + " not found")
        }
    }
}

export default {
    //* Show spinner with id "spinner-[elementId]" and hide element with id "[elementId]"
    show(elementId, anotherElementId) {
        // Call the below function
        waitForElementToDisplay('#spinner-' + elementId, function () {
            showAfterWait(elementId, anotherElementId)
        }, 50, 1000, elementId);
    },
    //* Hide spinner with id "spinner-[elementId]" and show element with id "[elementId]"
    hide(elementId, anotherElementId) {
        // Call the below function
        waitForElementToDisplay('#spinner-' + elementId, function () {
            hideAfterWait(elementId, anotherElementId)
        }, 500, 3000, elementId);
    },
    //* Show spinner and hide element
    // https://erikmartinjordan.com/wait-until-element-rendered-vif-vue
    //https://graffino.com/til/PJGbupe6WY-how-to-access-refs-outside-a-vuejs-template
    showByRef(spinner, element) {
        //var spinner = refs['spinner' + elementId];
        if (spinner != null) {
            spinner.style.display = 'block'
        } else {
            logger.debug("Could not show spinner.")
        }
        //var element = this.$root.$refs[elementId];
        if (element != null) {
            element.style.visibility = 'hidden'
        } else {
            logger.debug("Could not hide element.")
        }
    },
    //* Hide spinner and show elements
    // https://erikmartinjordan.com/wait-until-element-rendered-vif-vue
    //https://graffino.com/til/PJGbupe6WY-how-to-access-refs-outside-a-vuejs-template
    hideByRef(spinner, element) {
        //var spinner = this.$root.$refs['spinner-' + elementId];
        if (spinner != null) {
            spinner.style.display = 'none'
        } else {
            logger.debug("Could not hide spinner.")
        }
        //var element = this.$root.$refs[elementId];
        if (element != null) {
            element.style.visibility = 'visible'
        } else {
            logger.debug("Could not show element.")
        }
    },
    //* Hide all spinners (only use for error case)
    hideAll() {
        var spinners = document.querySelectorAll('sdx-loading-spinner');
        spinners.forEach(function (spinner) {
            spinner.style.display = 'none'
        })
    }

}
